import { render, staticRenderFns } from "./Paragraph_Intro.vue?vue&type=template&id=0f761e2c&scoped=true&"
import script from "./Paragraph_Intro.vue?vue&type=script&lang=js&"
export * from "./Paragraph_Intro.vue?vue&type=script&lang=js&"
import style0 from "./Paragraph_Intro.vue?vue&type=style&index=0&id=0f761e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f761e2c",
  null
  
)

export default component.exports